import type React from 'react';
import { useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/global.css';
import type { DrawerContentData } from '../components/RightDrawer';
import { SocketProvider } from '../contexts/SocketContext';
import { useTheme } from '../contexts/ThemeContext';
import { Login } from '../pages/Login';
import { AuthenticatedLayout } from './AuthenticatedLayout';
import styles from './App.module.css';

const toastStyle = { fontSize: '14px' } as const;

export const AppContent: React.FC = () => {
  const { isDarkMode } = useTheme();
  const [rightDrawerOpen, setRightDrawerOpen] = useState<boolean>(false);
  const [rightDrawerContent, setRightDrawerContent] = useState<DrawerContentData | null>(null);

  const openRightDrawer = (content: DrawerContentData): void => {
    setRightDrawerContent(content);
    setRightDrawerOpen(true);
  };

  const closeRightDrawer = (): void => {
    setRightDrawerOpen(false);
    setRightDrawerContent(null);
  };

  return (
    <SocketProvider>
      <Router>
        <div className={styles.appContainer}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="*"
              element={
                <AuthenticatedLayout
                  rightDrawerOpen={rightDrawerOpen}
                  rightDrawerContent={rightDrawerContent}
                  onOpenRightDrawer={openRightDrawer}
                  onCloseRightDrawer={closeRightDrawer}
                />
              }
            />
          </Routes>
        </div>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={isDarkMode ? 'dark' : 'light'}
        style={toastStyle}
      />
    </SocketProvider>
  );
};
